// src/services/openaiClient.js
// Cliente genérico para llamar a la API de OpenAI desde el front.

// HIPAA Compliance: API key must be stored in environment variables
// Add REACT_APP_OPENAI_API_KEY to your .env file
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;


if (!OPENAI_API_KEY) {
  // Ojo: esto solo ayuda en dev, no lo dejes así en prod
  console.warn(
    '[openaiClient] No se encontró VITE_OPENAI_API_KEY. Configura tu .env.local'
  );
}

/**
 * Llama al modelo de OpenAI usando /v1/chat/completions
 * @param {Object} params
 * @param {string} params.model - Nombre del modelo (ej: "gpt-4o-mini")
 * @param {Array} params.messages - Mensajes de la conversación [{role, content}]
 * @param {number} [params.temperature]
 */
export const callOpenAIChat = async ({
  model = 'gpt-4o-mini',
  messages,
  temperature = 0.3
}) => {
  const response = await fetch('https://api.openai.com/v1/chat/completions', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${OPENAI_API_KEY}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      model,
      messages,
      temperature
    })
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('[callOpenAIChat] Error HTTP:', response.status, errorText);
    throw new Error(`OpenAI error: ${response.status}`);
  }

  const data = await response.json();
  return data;
};


/**
 * ✅ Subir archivos a OpenAI Files API
 * Retorna { id: "file_..." }
 */
export const uploadFileToOpenAI = async (file) => {
  if (!file) throw new Error('No file provided');

  const form = new FormData();
  form.append('file', file);
  form.append('purpose', 'assistants'); // propósito recomendado para análisis (válido para files)

  const response = await fetch('https://api.openai.com/v1/files', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${OPENAI_API_KEY}`,
      // NO pongas Content-Type aquí (fetch lo setea con boundary)
    },
    body: form,
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('[uploadFileToOpenAI] Error HTTP:', response.status, errorText);
    throw new Error(`OpenAI upload error: ${response.status}`);
  }

  return response.json();
};

/**
 * ✅ Responses API (recomendada en documentación nueva) para usar PDFs como input (file_id).
 */
export const callOpenAIResponses = async ({ model = 'gpt-4o-mini', input }) => {
  const response = await fetch('https://api.openai.com/v1/responses', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${OPENAI_API_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      model,
      input,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('[callOpenAIResponses] Error HTTP:', response.status, errorText);
    throw new Error(`OpenAI responses error: ${response.status}`);
  }

  return response.json();
};